var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',[_c('div',{staticClass:"p-2"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }